import { useSelector } from "react-redux";
import { useGetTodosQuery } from "../redux/features/api/apiSlice";
import Todo from "./Todo";

export default function TodoList() {
  const { data: todos } = useGetTodosQuery();
  const filters = useSelector((state) => state.filters);

  const filterByStatus = (todo) => {
    const { status } = filters;
    switch (status) {
      case "Complete":
        return todo.completed;
      case "Incomplete":
        return !todo.completed;
      default:
        return true;
    }
  };

  const filterByColors = (todo) => {
    const { colors } = filters;
    if (colors.length > 0) {
      return colors.includes(todo?.color);
    }
    return true;
  };

  return (
    <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
      {todos &&
        todos
          .filter(filterByStatus)
          .filter(filterByColors)
          .map((todo) => <Todo todo={todo} key={todo.id} />)}
    </div>
  );
}
